// extracted by mini-css-extract-plugin
export default {"root":"QualityMark-root","iconWrapper":"QualityMark-iconWrapper","title":"QualityMark-title","description":"QualityMark-description"};